import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { flexDirection, flex } from 'styled-system'
import PreviewCompatibleImg from '../PreviewCompatibleImg'
import { Text, Heading, Box } from '../UI'

const CardStyled = styled(Box)`
  ${flexDirection}
`
const TextBox = styled(Box)`
  ${flex}
`

const Card = ({
  children,
  image,
  heading,
  text,
  backgroundFade,
  backgroundImage,
  textProps,
  headingProps,
  imageProps,
  textBoxProps,
  ...rest
}) => {
  return (
    <CardStyled
      {...rest}
      display="flex"
      overflow="hidden"
      style={{
        backgroundImage: backgroundImage
          ? backgroundFade
            ? `${backgroundFade}, url(${backgroundImage})`
            : backgroundImage
          : undefined,
      }}
      // backgroundImage={
      //   backgroundImage
      //     ? backgroundFade
      //       ? `${backgroundFade}, url(${backgroundImage})`
      //       : backgroundImage
      //     : null
      // }
    >
      {image ? (
        <PreviewCompatibleImg {...imageProps} image={image} />
      ) : (
        <Box className="post-image-placeholder" {...imageProps}></Box>
      )}
      <TextBox {...textBoxProps}>
        {heading && <Heading {...headingProps}>{heading}</Heading>}
        {text && <Text {...textProps}>{text}</Text>}
        {children && children}
      </TextBox>
    </CardStyled>
  )
}

Card.propTypes = {
  backgroundFade: PropTypes.string,
  backgroundImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  heading: PropTypes.string,
  headingProps: PropTypes.object,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  imageProps: PropTypes.object,
  text: PropTypes.string,
  textBoxProps: PropTypes.object,
  textProps: PropTypes.object,
}
Card.defaultProps = {
  backgroundFade: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), transparent)',
  boxShadow: 'small',
  borderRadius: 2,
  width: 1,
  textProps: { fontSize: 1 },
  headingProps: {},
  imageProps: {},
  // mx: 1,
  p: 0,
  // variant: 'basic',
  textBoxProps: {
    p: 2,
    width: 1,
  },
  flexDirection: 'column',
}

export default Card
